import React from 'react';
import _ from 'lodash';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import { TextField } from '@mui/material';

export const SmallFormDateField = props => {
  const { name, value, id, onChange, error, helperText, sx, label, variant } = props;

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} >
      <DatePicker
        id={id}
        inputFormat="yyyy-MM-dd"
        mask="____-__-__"
        autoOk
        name={name}
        value={value}
        onChange={onChange}
        label={label}
        sx={{ borderColor: 'red' }}
        error={true}
        renderInput={props => {
          props.error = error;

          return (
            <TextField error={error} helperText={helperText} variant={variant || 'outlined'} sx={{ width: '60%', ...sx, borderColor: 'red', maxWidth: '1200px' }} size="small" {...props} />
          );
        }}
        KeyboardButtonProps={{
          'aria-label': 'change date'
        }}
        PopperProps={{
          style: { zIndex: 35001 }
        }}
      />

    </LocalizationProvider>
  );
};
